import THEME from '@maxpreps/shared/styles/colors';
import Font from '@maxpreps/shared/styles/font';
import StyledText from '@maxpreps/shared/ui/Text/StyledText';
import React from 'react';
import styled from 'styled-components';

const StyledRecordDetailsBox = styled.div`
  padding: 0 16px;

  &:first-child {
    border-right: 1px solid ${THEME.general.border};
  }
`;

const StyledDetailsRow = styled(StyledText)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface IRecordDetailsBoxProps {
  rows: any[];
}

const RecordDetailsBox: React.FC<IRecordDetailsBoxProps> = ({ rows = [] }) => (
  <StyledRecordDetailsBox>
    {rows.map(row => (
      <StyledDetailsRow
        key={row.label}
        className={Font.f11_bold_tall_upper}
        $color={THEME.text.tertiary}
      >
        {row.label}
        <StyledText $color={row.color || THEME.text.primary}>
          {row.value}
        </StyledText>
      </StyledDetailsRow>
    ))}
  </StyledRecordDetailsBox>
);

export default RecordDetailsBox;
